export class UserSettingConsts {
  /**
   * Mã định danh (Type) dùng để lưu cấu hình ẩn/hiển cột và export Excel.
   * Dành cho module Báo cáo theo trang.
   */
  static readonly TYPE_DG_COLUMN_REPORT_PAGE = 88001;
  /**
   * Dành cho module Báo cáo tương tác
   */
  static readonly TYPE_DG_COLUMN_REPORT_INTERACTIVE = 88002;
  /**
   * Dành cho module Báo cáo tag
   */
  static readonly TYPE_DG_COLUMN_REPORT_TAG = 88003;
  /**
   * Dành cho module Báo cáo bài viết / quảng cáo
   */
  static readonly TYPE_DG_COLUMN_REPORT_POST = 88004;
  /**
   * Dành cho module Báo cáo nhân viên
   */
  static readonly TYPE_DG_COLUMN_REPORT_STAFF = 88005;
  /**
   * Mã định danh dành cho module Khách hàng
   */
  static readonly TYPE_DG_COLUMN_CUSTOMER = 22001;
  /**
   * Dành cho module Báo cáo FBAD
   */
  static readonly TYPE_DG_COLUMN_REPORT_FBAD = 88006;
  /**
   * Dành cho module Báo cáo Livestreams
   */
  static readonly TYPE_DG_COLUMN_REPORT_LIVESTREAMS = 88007;
  /**
   * Dành cho module báo cáo chốt đơn tự động
   */
  static readonly TYPE_DG_COLUMN_REPORT_LIVESHOPPING = 88008;
  /**
   * Dành cho module báo cáo tin nhắn chatbot
   */
  static readonly TYPE_DG_COLUMN_REPORT_CHATBOT_MESSAGE = 88009;
  /**
   * Danh cho module bao cao danh gia chatbot
   */
  static readonly TYPE_DG_COLUMN_REPORT_CHATBOT_FEEDBACK = 88011;
  static readonly TYPE_DG_COLUMN_REPORT_CHATBOT_MARKETING = 88012;
  static readonly TYPE_DG_COLUMN_CHATBOT_MARKETING_CUSTOMERS = 88013;
  /**
   * Dành cho module chatbot AI
   */
  static readonly TYPE_DG_COLUMN_REPORT_CHATBOT_AI_ASSISTANT = 88014;
  /**
   * Dành cho module báo cáo Business Agent
   */
  static readonly TYPE_DG_COLUMN_REPORT_METABIZ = 88010;
  /**
   * Đành cho module báo cáo lịch sử nhận / chuyển hội thoại
   */
  static readonly TYPE_DG_COLUMN_REPORT_SPLIT = 88014;
  /**
   * Dành cho module báo cáo meta capi
   */
  static readonly TPYE_DG_COLUMN_REPORT_META_CAPI = 88015;
  static readonly TYPE_DG_COLUMN_REPORT_META_CAPI_DETAIL = 88022;
  static readonly TYPE_DG_COLUMN_REPORT_META_CAPI_RETURN_REVENUE = 88023;
  /**
   * Dánh cho live stream
   */
  static readonly TYPE_DG_COLUMN_LIVESTREAM_COMMENT = 88016;
  /**
   * Dành cho listScript
   */
  static readonly TYPE_DG_COLUMN_LISTSCRIPT = 88017;
  
  static readonly TYPE_DG_COLUMN_REPORT_THREADS = 88018;

  /**
   * Dành cho report fmm
   */
  static readonly TYPE_DG_COLUMN_REPORT_FMM = 88019;
  /**
   * Dành cho report conversation
   */
  static readonly TYPE_DG_COLUMN_REPORT_CONVERSATION = 88020;
  /**
   * Dành cho report affiliateCode
   */
  static readonly TYPE_DG_COLUMN_REPORT_AFFILIATE_CODE = 88021;
}
